import React, { Component } from 'react';
import Marquee from 'react-fast-marquee';
import img1 from '../assets/images/partners/images/one.svg';
import img2 from '../assets/images/partners/images/inttix.png';
import img3 from '../assets/images/partners/images/bp.svg';
import img4 from '../assets/images/partners/images/cerberus.svg';
import img5 from '../assets/images/partners/images/geria.svg';
import img6 from '../assets/images/partners/images/Accenture.svg';
import img7 from '../assets/images/partners/images/mediaagility.webp';
import img8 from '../assets/images/partners/images/liveli.png';
import img9 from '../assets/images/partners/images/aws.svg';
import img10 from '../assets/images/partners/images/asml.svg';
import img11 from '../assets/images/partners/images/sophos.png';
import img12 from '../assets/images/partners/images/government.76baa520414e7bc86d30d3ac83ace085.svg';
import img13 from '../assets/images/partners/images/GTCO_logo.svg';
import img14 from '../assets/images/partners/images/BR_logo.svg';
import img15 from '../assets/images/partners/images/MaxFiles-logo.svg';
import img16 from '../assets/images/partners/images/convexity.svg';
import img17 from '../assets/images/partners/images/phastpay.svg';
import img18 from '../assets/images/partners/images/Ican.svg';
import img19 from '../assets/images/partners/images/checkpoint.svg';

class Partners extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="partners-section">
                    <p className="headings">Our Trusted Partners & Clients</p>
                    <Marquee
                        direction="right"
                        speed={100}
                        delay={5}
                    >
                        <div className="image_wrapper">
                            <img
                                src={img1}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img2}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img3}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img4}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div>
                            <img
                                src={img5}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img6}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img7}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img8}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img9}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img10}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img11}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img12}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img13}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img14}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img15}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img16}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img17}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img18}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                        <div className="image_wrapper">
                            <img
                                src={img19}
                                alt="Our Trusted Partners & Clients logo"
                            />
                        </div>
                    </Marquee>
                </div>
            </React.Fragment>
        );
    }
}

export default Partners;
